import AnchorButton from 'components/AnchorButton';
import AppealDescriptionPos from 'content/category-content/pos-systems/appeal-description.md';
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  AnchorButton,
  AppealDescriptionPos,
  React,
  MDXTag
};